import { render, staticRenderFns } from "./notificacionesAdd.vue?vue&type=template&id=77d89e68&"
import script from "./notificacionesAdd.vue?vue&type=script&lang=js&"
export * from "./notificacionesAdd.vue?vue&type=script&lang=js&"
import style0 from "./notificacionesAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports